webpackJsonp([3],{

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(226);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("2d200183", content, true);

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, ".select-icon[data-v-2af2da2f]{margin-left:.42667rem;height:.96rem;line-height:.96rem;width:.96rem;text-align:center;color:#fff;font-size:18px;background-color:#e78081;border-radius:4px}", "", {"version":3,"sources":["/opt/build/repo/src/views/EditHistory.vue"],"names":[],"mappings":"AACA,8BACE,sBAAwB,AACxB,cAAgB,AAChB,mBAAqB,AACrB,aAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,eAAgB,AAChB,yBAA0B,AAC1B,iBAAmB,CACpB","file":"EditHistory.vue","sourcesContent":["\n.select-icon[data-v-2af2da2f] {\n  margin-left: 0.42667rem;\n  height: 0.96rem;\n  line-height: 0.96rem;\n  width: 0.96rem;\n  text-align: center;\n  color: #fff;\n  font-size: 18px;\n  background-color: #e78081;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_simple_vue_validator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var type = this.$route.query.type;
    var histories = this.$store.getters[type + 'Histories'];

    var _ref = this.$route.params.id ? Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* first */])(histories, function (history) {
      return history.id === _this.$route.params.id;
    }) : { item: null },
        item = _ref.item,
        index = _ref.index;

    return {
      type: type,
      index: index,
      form: {
        name: item ? item.name : '',
        tag: item ? item.tag : '',
        amount: item ? +item.amount : 100,
        date: item ? item.date : Object(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* format */])(new Date(), 'yyyy-MM-dd')
      },
      submitted: false,
      notInTags: false,
      notInContactNames: [],
      names: [],
      showContacts: false,
      showTags: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(['contacts', 'tags']), {
    isEdit: function isEdit() {
      return !!this.$route.params.id;
    },
    contactNames: function contactNames() {
      return this.contacts.map(function (contact) {
        return contact.name;
      });
    },
    title: function title() {
      return (this.isEdit ? '修改' : '添加') + (this.type === 'sent' ? '支出' : '收入');
    }
  }),
  components: {
    ContactsManage: function ContactsManage() {
      return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 228));
    },
    TagsManage: function TagsManage() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 231));
    }
  },
  validators: {
    'form.name': {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_3_simple_vue_validator__["Validator"].value(v).required('名称必填');
      }
    },
    'form.tag': {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_3_simple_vue_validator__["Validator"].value(v).required('分类必选');
      }
    },
    'form.amount': {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_3_simple_vue_validator__["Validator"].value(v).float().required('金额必填').greaterThan(0, '金额不能小于0哦');
      }
    },
    'form.date': {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_3_simple_vue_validator__["Validator"].value(v).required('必选');
      }
    }
  },
  watch: {
    'form.name': __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function () {
      var _this2 = this;

      var v = this.form.name.trim();
      if (v) {
        this.names = v.split(/,|，| /).filter(function (name) {
          return name;
        });
        this.notInContactNames = this.names.filter(function (name) {
          return _this2.contactNames.indexOf(name) < 0;
        });
      } else {
        this.names = [];
        this.notInContactNames = [];
      }
    }, 500),
    'form.tag': __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function () {
      var v = this.form.tag.trim();
      this.notInTags = !!v && !this.tags.some(function (tag) {
        return v === tag.name;
      });
    }, 500)
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])(['addHistory', 'updateHistory', 'addContact', 'addTag']), {
    onContactsSelect: function onContactsSelect(selections) {
      this.form.name = selections.map(function (contact) {
        return contact.name;
      }).toString();
      this.showContacts = false;
    },
    onTagsSelect: function onTagsSelect(selections) {
      this.form.tag = selections[0].name;
      this.showTags = false;
    },
    autoAddContacts: function autoAddContacts() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(this.notInContactNames.map(function (name) {
        return _this3.addContact(name.trim());
      })).then(function () {
        _this3.$toast('已自动添加所有联系人');
        _this3.notInContactNames = [];
      }).catch(function () {
        _this3.$toast('联系人添加失败，请继续使用');
      });
    },
    autoAddTag: function autoAddTag() {
      var _this4 = this;

      this.addTag(this.form.tag.trim()).then(function () {
        _this4.$toast('已自动添加该分类');
        _this4.notInTags = false;
      }).catch(function () {
        _this4.$toast('分类添加失败，请继续使用');
      });
    },
    save: function save() {
      var _this5 = this;

      this.submitted = true;
      this.$validate().then(function (isSuccess) {
        if (isSuccess) {
          if (_this5.form.tag.indexOf(',') > -1) {
            return _this5.$toast('分类不支持添加多个');
          }

          if (_this5.isEdit && _this5.form.name.indexOf(',') > -1) {
            return _this5.$toast('编辑时姓名只能为1个');
          }
          var promise = void 0;
          if (_this5.isEdit) {
            promise = _this5.updateHistory([_this5.type, _this5.index, _this5.form]).then(function () {
              _this5.$toast('记录已修改');
            });
          } else {
            promise = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(_this5.names.map(function (name) {
              return _this5.addHistory([_this5.type, {
                name: name,
                tag: _this5.form.tag,
                amount: _this5.form.amount,
                date: _this5.form.date
              }]);
            })).then(function () {
              _this5.$toast('记录已添加');
            });
          }
          promise.then(function () {
            _this5.$router.go(-1);
          }).catch(function (e) {
            _this5.$toast(e.toString());
          });
        }
      });
    }
  }),
  created: function created() {
    if (!this.$route.query.type) {
      this.$router.go(-1);
    }
  }
});

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": ""
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('form', {
    staticClass: "scrollable container flex-1",
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "flex form-control"
  }, [_c('u-input', {
    staticClass: "flex-1",
    attrs: {
      "placeholder": '请输入对方称呼' + (_vm.isEdit ? '只支持单人' : '，用逗号或空格间隔'),
      "autofocus": "",
      "tabindex": "1"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  }, [(_vm.submitted && _vm.validation.hasError('form.name')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('form.name')))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "gift icon-contacts select-icon",
    on: {
      "click": function($event) {
        _vm.showContacts = true
      }
    }
  }), _vm._v(" "), (_vm.notInContactNames.length) ? _c('span', {
    staticClass: "gift icon-plus select-icon",
    on: {
      "click": _vm.autoAddContacts
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex form-control"
  }, [_c('u-input', {
    staticClass: "form-control flex-1",
    attrs: {
      "placeholder": "请选择礼钱分类，只支持单个分类",
      "tabindex": "2"
    },
    model: {
      value: (_vm.form.tag),
      callback: function($$v) {
        _vm.form.tag = $$v
      },
      expression: "form.tag"
    }
  }, [(_vm.submitted && _vm.validation.hasError('form.tag')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('form.tag')))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "gift icon-book select-icon",
    on: {
      "click": function($event) {
        _vm.showTags = true
      }
    }
  }), _vm._v(" "), (_vm.notInTags) ? _c('span', {
    staticClass: "gift icon-plus select-icon",
    on: {
      "click": _vm.autoAddTag
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "请输入礼钱数额",
      "tabindex": "3"
    },
    model: {
      value: (_vm.form.amount),
      callback: function($$v) {
        _vm.form.amount = _vm._n($$v)
      },
      expression: "form.amount"
    }
  }, [(_vm.submitted && _vm.validation.hasError('form.amount')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('form.amount')))]) : _vm._e()]), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "tabindex": "4"
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.form.date = $$v
      },
      expression: "form.date"
    }
  }, [(_vm.submitted && _vm.validation.hasError('form.date')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('form.date')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('u-popup', {
    attrs: {
      "effect": "right",
      "full": ""
    },
    model: {
      value: (_vm.showContacts),
      callback: function($$v) {
        _vm.showContacts = $$v
      },
      expression: "showContacts"
    }
  }, [_c('contacts-manage', {
    attrs: {
      "selection": -1
    },
    on: {
      "back": function($event) {
        _vm.showContacts = false
      },
      "select": _vm.onContactsSelect
    }
  })], 1), _vm._v(" "), _c('u-popup', {
    attrs: {
      "effect": "right",
      "full": ""
    },
    model: {
      value: (_vm.showTags),
      callback: function($$v) {
        _vm.showTags = $$v
      },
      expression: "showTags"
    }
  }, [_c('tags-manage', {
    attrs: {
      "selection": 1
    },
    on: {
      "back": function($event) {
        _vm.showTags = false
      },
      "select": _vm.onTagsSelect
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2af2da2f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/3.26b22e08cc9a98af5739.js